<template>
  <div class="chart-box container">
    <el-tabs v-model="activeName" type="border-card" style="margin: 30px 0;">
      <el-tab-pane label="全部成果" name="first">
        <el-row :gutter="20" style="padding: 30px 0">
          <el-col :span="6" class="results-left">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>科室成果</span>
                <el-button
                  style="float: right;"
                  size="mini"
                  icon="el-icon-plus"
                  @click="addAttention"
                >关注</el-button>
              </div>
              <div class="guo">
                <p class="guo-text">总成果</p>
                <p class="guo-num">{{allResult}}</p>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 20px">
              <div slot="header" class="clearfix">
                <span>年度发文趋势</span>
              </div>
              <div id="yearChart" ref="yearChart" :style="{width: '100%', height: '230px'}"></div>
            </el-card>
            <el-card class="box-card" style="margin-top: 20px">
              <div slot="header" class="clearfix">
                <span>期刊发文统计</span>
              </div>
              <div id="countChart" ref="countChart" :style="{width: '100%', height: '400px'}"></div>
            </el-card>
          </el-col>
          <el-col :span="18">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>重要成果</span>
              </div>
              <el-card class="box-card" shadow="never">
                <el-row class="type-item">
                  <el-col class="type-left" :span="2">类型：</el-col>
                  <el-col :span="22">
                    <el-tag
                      v-for="(item,index) in typeList"
                      size="small"
                      :type="typeIndex===index?'success':'info'"
                      :key="index"
                      v-if="item.typeNum != 0"
                      @click="changeType(item.baseType,index)"
                    >{{item.typeName}}（{{item.typeNum}}）</el-tag>
                  </el-col>
                </el-row>
                <el-row class="type-item">
                  <el-col class="type-left" :span="2">选择：</el-col>
                  <el-col :span="22">
                    <el-tag
                      v-for="(item,index) in fullList"
                      size="small"
                      :type="fullIndex===index?'success':'info'"
                      :key="index"
                      @click="changeFull(item.val,index)"
                    >{{item.text}}</el-tag>
                  </el-col>
                </el-row>
                <el-row class="type-item">
                  <el-col class="type-left" :span="2">年度：</el-col>
                  <el-col :span="22">
                    <el-tag
                      v-for="(item,index) in yearList"
                      size="small"
                      :type="yearIndex===index?'success':'info'"
                      :key="index"
                      v-if="item.yearNum != 0"
                      @click="changeYear(item.year,index)"
                    >{{item.year}}（{{item.yearNum}}）</el-tag>
                  </el-col>
                </el-row>
              </el-card>
              <el-row class="type-opr">
                <el-col :span="12">
                  <el-button
                    type="primary"
                    size="medium"
                    plain
                    icon="el-icon-download"
                    @click="excelDown"
                  >导出excel</el-button>
                </el-col>
                <el-col :span="12" style="text-align: right">
                  <span>排序方式：</span>
                  <el-button-group>
                    <el-button
                      :type="searchForm.sortType==='XZL'?'success':'primary'"
                      @click="changeSort('XZL')"
                      size="medium"
                      plain
                    >
                      下载量
                      <i class="el-icon-bottom el-icon--right"></i>
                    </el-button>
                    <el-button
                      :type="searchForm.sortType==='LLS'?'success':'primary'"
                      @click="changeSort('LLS')"
                      size="medium"
                      plain
                    >
                      浏览数
                      <i class="el-icon-bottom el-icon--right"></i>
                    </el-button>
                  </el-button-group>
                </el-col>
              </el-row>
              <el-card class="box-card result-card" shadow="never">
                <div slot="header" class="clearfix">
                  <span>
                    筛选结果
                    <b>{{total}}条</b>
                  </span>
                </div>
                <el-checkbox-group v-model="checkList">
                  <div v-for="item in dataList" :key="item.id" class="text item">
                    <p>
                      <el-checkbox :label="item.id" class="list-check"></el-checkbox>
                      <el-tag type="primary" size="mini" plain>{{item.includeInfo}}</el-tag>
                    </p>
                    <p>
                      <b>
                        <router-link
                          class="recommend"
                          :to="{path:'details',query:{baseId:item.id,baseType:item.baseType}}"
                        >{{item.title}}</router-link>
                      </b>
                    </p>
                    <p>
                      <b>作者：</b>
                      {{item.author}}
                    </p>
                    <!-- <p><b>刊名：</b>Chinese journal of traumatology = Zhonghua chuang shang za zhi</p>
                    <p><b>年卷期页：</b>220-8</p>-->
                    <p style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
                      <b>摘要：</b>
                      {{item.summary}}
                    </p>
                  </div>
                </el-checkbox-group>
              </el-card>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :current-page="currentPage"
                :page-size="pageSizes"
                @current-change="currentChange"
                style="text-align: right"
              ></el-pagination>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="科室成员" name="second">
        <div class="member_style">
          <router-link
            v-for="item in membersList"
            :key="item.userId"
            :to="{path:'personal',query:{id:item.userId}}"
          >
            <!-- <p style="width:90px;height:90px;margin:auto">
              <img :src="item.imgUrl" alt style="width:100%;height:100%" />
            </p> -->
            <p style="margin-top:5px">{{item.userName}}</p>
          </router-link>
        </div>
      </el-tab-pane>
      <el-tab-pane label="获奖情况" name="third">
        <el-tag v-for="(item,index) in orgAwardsList" size="small" :key="index"></el-tag>
        <div style="text-align:center" ><img src="../assets/images/2.jpg" alt /></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from 'axios'
import List from '../components/list'
import Tags from '../components/tags'
import Operation from '../components/operation'
import Pages from '../components/pages.vue'
import YearChart from '../components/year-chart.vue'
import CountChart from '../components/count-chart.vue'
export default {
  name: 'index',
  components: {
    List,
    Tags,
    Operation,
    Pages,
    YearChart,
    CountChart,
  },
  data() {
    return {
      url:
        'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      activeName: 'first',
      userId: '',
      orgId: '',
      total: 0,
      currentPage: 1,
      pageSizes: 5,
      fullIndex: 0,
      typeIndex: 0,
      yearIndex: 0,
      searchForm: {
        typeVal: '0',
        fullFlag: '-1',
        sortType: 'XZL',
        yearVal: '-1',
        pageNo: 1,
      },
      typeList: [],
      fullList: [
        { val: '-1', text: '所有' },
        { val: '1', text: '包含全文' },
        { val: '0', text: '不包含全文' },
      ],
      yearList: [],
      dataList: [],
      checkList: [],
      detailsData: {
        irUser: {},
        dissNum: 0,
        fullNum: 0,
        columnYearNum: [],
        columnYear: [],
        rtnVal: {},
        journalCountList: [],
      },
      membersList: [],
      orgAwardsList: [],
      allResult: this.$route.query.allResult,
    }
  },
  created() {},
  methods: {
    currentChange(val) {
      this.searchForm.pageNo = val
      this.searchData()
    },
    yearChart() {
      let list = this.detailsData.allyear
      let xdata = []
      let ydata = []
      for (var i in list) {
        xdata.push(list[i].year)
        ydata.push(list[i].yearNum)
      }
      console.log(xdata, ydata)
      let option = {
        title: {
          text: '',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: ['年度发文趋势'],
        },
        grid: {
          left: '0%',
          right: '0%',
          top: '10%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: xdata,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: '年度发文趋势',
            type: 'bar',
            data: ydata,
            barWidth: 30,
            itemStyle: {
              normal: {
                color: function (params) {
                  // build a color map as your need.
                  var colorList = [
                    '#C1232B',
                    '#B5C334',
                    '#FCCE10',
                    '#E87C25',
                    '#27727B',
                    '#FE8463',
                    '#9BCA63',
                    '#FAD860',
                    '#F3A43B',
                    '#60C0DD',
                    '#D7504B',
                    '#C6E579',
                    '#F4E001',
                    '#F0805A',
                    '#26C0C0',
                  ]
                  return colorList[params.dataIndex]
                },
              },
            },
          },
        ],
      }
      let yearChart = this.$echarts.init(document.getElementById('yearChart'))
      yearChart.setOption(option)
    },
    countChart() {
      let option = {
        title: {
          text: '',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
        },
        legend: {
          x: 'left',
          //                        left: 10
          orient: 'vertical',
        },
        series: [
          {
            type: 'pie',
            radius: ['38%', '83%'],
            center: ['50%', '66%'],

            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center',
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '15',
                  fontWeight: 'bold',
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: this.detailsData.journalVos,
          },
        ],
      }
      let countChart = this.$echarts.init(document.getElementById('countChart'))
      countChart.setOption(option)
    },
    addAttention() {
      axios({
        method: 'post',
        //url: '/api/Depart/org/addAttention?userId='+Number(this.$cookies.get('rtnVal'))+'&orgid='+Number(this.$route.query.id),
        url: '/api/Depart/org/addAttention',
        data: {
          userId: Number(this.$cookies.get('rtnVal')),
          orgid: Number(this.$route.query.id),
        },
      })
        .then(function (response) {
          alert(response.data.msg)
          console.log(response)
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
    getAllDep(data) {
      let currThis = this
      axios({
        method: 'get',
        url: '/api/Depart/org/' + data.id + '/result',
      })
        .then(function (response) {
          //console.log(response);
          let typeArr = [
            {
              baseType: '0',
              typeNum: response.data.data.ALLCount,
              typeName: '所有',
            },
          ]
          let yearArr = [{ year: '所有', yearNum: response.data.data.yearAll }]
          currThis.typeList = typeArr.concat(response.data.data.TypeNums)
          currThis.yearList = yearArr.concat(response.data.data.yearNums)
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
    searchData(data) {
      let currThis = this
      let obj = this.searchForm
      obj.orgid = this.orgId

      axios({
        method: 'post',
        url: '/api/Depart/org/result/page?orgid=' + obj.orgid,
        data: obj,
      })
        .then(function (response) {
          //console.log(response);
          currThis.currentPage = response.data.data.current
          currThis.total = response.data.data.total
          currThis.pageSizes = response.data.data.size
          currThis.dataList = response.data.data.records
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
    excelDown() {
      let data = ''
      for (var i = 0; i < this.checkList.length; i++) {
        if (i === 0) {
          data += 'a' + this.checkList[i] + 'a'
        } else {
          data += this.checkList[i] + 'a'
        }
      }
      console.log(data)
      axios({
        method: 'get',
        url: '/api/index/exportExcel/1',
      })
        .then(function (response) {
          console.log(response)
          if (response.status === 200) {
            alert('导出成功')
          } else {
          }
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
    changeSort(val) {
      this.searchForm.sortType = val
      this.searchData()
    },
    changeType(val, index) {
      this.searchForm.typeVal = val
      this.typeIndex = index
      this.searchData()
    },
    changeFull(val, index) {
      this.searchForm.fullVal = val
      this.fullIndex = index
      this.searchData()
    },
    changeYear(val, index) {
      this.searchForm.yearVal = val
      this.yearIndex = index
      this.searchData()
    },
    getDetails(data) {
      let currThis = this
      axios({
        method: 'get',
        url: '/api/Depart/org/' + data.id,
      })
        .then(function (response) {
          console.log(response)
          currThis.detailsData = response.data.data
          currThis.countChart()
          currThis.yearChart()
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
    getMembers(data) {
      let currThis = this
      axios({
        method: 'get',
        url: '/api/Depart/org/' + data.id + '/members',
      })
        .then(function (response) {
          currThis.membersList = response.data.data.orgMembers
          //console.log(response);
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
    getJiang(data) {
      let currThis = this
      axios({
        method: 'post',
        url: '/api/Depart/awards/' + data.id,
      })
        .then(function (response) {
          console.log(response)
          currThis.orgAwardsList = response.data.data.orgAwardsList
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
  },
  mounted() {
    this.orgId = this.$route.query.id
    this.getAllDep(this.$route.query)
    this.getDetails(this.$route.query)
    this.searchData(this.$route.query)
    this.getMembers(this.$route.query)
    this.getJiang(this.$route.query)
  },
}
</script>

<style scoped>
.member_style{
	width: 100%;
	height: 100%;
	display: flex;
	flex-wrap: wrap;
}
.member_style>a{
	width: 25%;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/department.vue